import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { getTenantScope, endpoints, setTenantScope } from "@/lib/api";
import { toast } from "sonner";

const AREA_MAP = [
  { rx: /^\/clients\/[^/]+/, area: "overview" },
  { rx: /^\/ncrs/, area: "ncrs" },
  { rx: /^\/objectives/, area: "objectives" },
  { rx: /^\/suppliers/, area: "suppliers" },
  { rx: /^\/employees/, area: "employees" },
  { rx: /^\/trainings/, area: "trainings" },
  { rx: /^\/competency-matrix/, area: "matrix" },
  { rx: /^\/documents/, area: "documents" },
  { rx: /^\/billing/, area: "billing" },
  { rx: /^\/calendar/, area: "calendar" },
  { rx: /^\/audits-reviews/, area: "job_packs" },
];

export default function AuditorBanner() {
  const [scope, setScope] = useState(getTenantScope());
  const location = useLocation();

  useEffect(() => {
    const onChange = () => setScope(getTenantScope());
    window.addEventListener("isoquest:scope-changed", onChange);
    return () => window.removeEventListener("isoquest:scope-changed", onChange);
  }, []);

  // Log route visits for auditor session
  useEffect(() => {
    if (scope?.role !== "auditor") return;
    const match = AREA_MAP.find(m => m.rx.test(location.pathname));
    if (!match) return;
    endpoints.auditorLog(match.area, `path=${location.pathname}`);
  }, [scope?.role, location.pathname]);

  if (scope?.role !== "auditor") return null;
  const exit = () => { setTenantScope(null); toast.success("Auditor session ended"); setTimeout(() => { window.location.href = "/"; }, 200); };

  const expiresLabel = scope.expires_at ? new Date(scope.expires_at).toLocaleString(undefined, { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "—";

  return (
    <div data-testid="auditor-banner" className="fixed left-0 right-0 top-16 z-40 px-3 sm:px-5 py-2 flex items-center gap-3 bg-purple-100/95 dark:bg-purple-500/25 backdrop-blur border-b border-purple-300 dark:border-purple-500/40 text-purple-900 dark:text-purple-100 shadow-sm">
      <ShieldCheck className="h-4 w-4 shrink-0" />
      <div className="text-xs font-semibold min-w-0 flex-1 truncate">
        Read-only auditor session · <span className="font-bold">{scope.auditor_name || "External auditor"}</span> · scoped to <span className="font-bold">{scope.company_name || scope.slug}</span> · expires {expiresLabel}
      </div>
      <button data-testid="auditor-exit" onClick={exit} className="text-xs font-semibold underline underline-offset-2 hover:text-purple-950 dark:hover:text-white shrink-0">Exit</button>
    </div>
  );
}
